import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-164">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-165">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-navy/60 backdrop-blur-sm" onClick={onClose} data-id="element-166" />

          {/* Modal content */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[80vh] overflow-hidden z-10" data-id="element-167">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-stone-100" data-id="element-168">
              <h2 className="text-lg font-bold text-navy" data-id="element-169">{title}</h2>
              <button onClick={onClose} className="p-1.5 rounded-full hover:bg-stone-100 transition-colors text-navy/50 hover:text-navy" aria-label="Cerrar" data-id="element-170">
                <X className="w-5 h-5" data-id="element-171" />
              </button>
            </div>

            {/* Body */}
            <div className="px-6 py-5 overflow-y-auto max-h-[calc(80vh-64px)] text-navy/70 text-sm leading-relaxed space-y-4" data-id="element-172">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}